import axios from 'axios'

export function request (config) {
  // 1.创建axios的实例
  const instance = axios.create({
    baseURL: 'https://bcs.qianxin.com',
    headers: {
      'Content-Type': 'application/json'
    },
    timeout: 20000
  })

  // 2.axios请求拦截器
  instance.interceptors.request.use(config => {
    // console.log(config)
    return config
  }, err => {
    console.log(err)
  })
  // 2.2 响应拦截器
  instance.interceptors.response.use(res => {
    // console.log(res)
    return res
  }, err => {
    console.log(err)
  })

  // 3.发送真正的网络请求
  return instance(config)
}
